import CONSENT_SOURCE_TYPES from './CONSENT_SOURCE_TYPES';

export default function deriveCmpPreset(consentSource) {
  if (consentSource?.type === CONSENT_SOURCE_TYPES.CMP) return consentSource.provider;

  // A concrete empty value clears staged presets and requires a choice when switching to Supported CMP.
  return '';
}
